import {gql} from 'apollo-boost'

export const GET_LEVELS = gql`
    query {
        levels {
            id
            name
        }
    }
`

export const ADD_LEVEL = gql`
    mutation($name: String!) {
        createLevel(name: $name) {
            id
            name
        }
    }
`

export const UPDATE_LEVEL = gql`
    mutation($id: ID! $name: String!) {
        updateLevel(id: $id name: $name) {
            id
            name
        }
    }
`

export const DELETE_LEVEL = gql`
    mutation($id: ID!) {
        deleteLevel(id: $id) {
            name
        }
    }
`